import { Component, OnInit, ChangeDetectorRef, ViewEncapsulation } from '@angular/core';
import { NavController, MenuController } from '@ionic/angular';

import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';

import { Constants } from "../../models/constants";

import { MainScreenContent } from '../../services/main-screen-content';
import { ApptCreator } from "../../services/appt-creation-service";
import { UserService } from "../../services/user-service";
import { Util } from "../../services/util";
import { NavigationExtras } from '@angular/router';

import { MetaTagService } from 'src/app/services/meta-tag-service';
import { ObservableService } from 'src/app/services/observable-service';

@Component({
  selector: 'app-all-pros',
  templateUrl: './all-pros.page.html',
  styleUrls: ['./all-pros.page.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AllProsPage implements OnInit {

  profPicThumbURL = "assets/img/profile-placeholder.png";
  placeholderURL = "assets/img/profile-placeholder.png";

  emptyStateNoLocation = false;
  errorString: string

  screenItems?: any[];

  searchingCurrentLocation = false;

  constructor(
    private observables: ObservableService,
    private navCtrl: NavController,
    private inAppBrowser: InAppBrowser,
    private changeRef: ChangeDetectorRef,
    public apptCreator: ApptCreator,
    public userService: UserService,
    private menuCtrl: MenuController,
    private metaTagService: MetaTagService
  ) { }

  ngOnInit() {}

  ngAfterViewInit() {

    this.observables.publishUpdateUser()

    const business = this.userService.business

    if (!business) {
      const sub = this.observables.businessFetched.subscribe(() => {
        sub.unsubscribe()
        let eventualLoad = true
        this.loadInitialContent(eventualLoad)
      });
      return
    }

    this.loadInitialContent()

  }

  ionViewWillEnter() {

    this.metaTagService.updateTitle('My Team')
    // this.metaTagService.updateTags({
    //   facebookURL: 'https://app.getshortcut.co/explore',
    //   keywords: 'search Pros, in home haircuts, on demand haircuts, local barbers, local stylists',
    //   facebookTitle: 'Search Pros | Shortcut',
    //   twitterTitle: 'Search Pros | Shortcut',
    //   description: 'Find local Pros for in-home services through Shortcut.',
    //   facebookDescription: 'Find local Pros for in-home services through Shortcut.',
    //   twitterDescription: 'Find local Pros for in-home services through Shortcut.',
    // })

    this.menuCtrl.enable(true);
  }

  ionViewDidEnter() {
    this.observables.publishSetCurrentMenuRoot('/team')
    this.changeRef.detectChanges()
  }

  ionViewWillLeave() {
  }

  loadInitialContent(eventualLoad?: boolean) {

    this.executePullContent();

    if (this.userService.business) {
      this.placeholderURL = this.userService.business.pic
    }

    if (eventualLoad) {
      this.changeRef.detectChanges()
    }
  }

  openSccToThisPage() {
    window.open(`${Constants.SCC_ADMIN_URL}/#/businessPros`, '_blank')
  }


  // Get the content

  executePullContent(refresher?: any) {

    this.errorString = undefined

    MainScreenContent.loadBusiness((content: any[]) => {
        this.loadedContent(content);
        if (refresher) refresher.target.complete();
      },
      (msg: string) => {
        if (!Util.isNavigationError(msg)) {
          this.error(msg);
        }
        this.errorString = msg
        if (refresher) refresher.target.complete();
      });
  }


  //
  // -- Helpers --
  //

  openURL(url: string) {
    this.inAppBrowser.create(url, "_blank")
  }

  formatCost(n: number, currency: string) {
    return Util.formatCost(n, currency);
  }

  private loadedContent(content: any[]) {
    for (let item of content) {
      if (item.type == 'day-segment-group' || item.type == 'barber-group') {

        if (item.avails.length > 4) {
          item.showingAvails = item.avails.slice(0, 4)
          item.hasShowMore = true
        } else {
          item.showingAvails = item.avails
        }
      }
    }

    this.screenItems = content;
    this.changeRef.detectChanges()
  }

  showMoreAvails(item) {
    item.showingAvails = item.avails
    item.hasShowMore = false
    this.changeRef.detectChanges()
  }

  private error(msg: string) {
    console.error(msg)
  }

  private reset() {
    this.screenItems = [];
    this.emptyStateNoLocation = false;
  }



  // Navigation

  getAdjustedDisplayTime(time: Date, timezoneOffset: number) {
    return Util.prettyTimeAdjusted(time, { offset: timezoneOffset, abbr: undefined })
  }

  stringToDate(timeString: string) {
    return new Date(timeString)
  }

  goToBarber(barberLink: string, barberProfileNavHistory: string, selectedDate?: Date, canBook?: boolean) {

    const navigationExtras: NavigationExtras = {
      state: {
        barberProfileNavHistory,
        apptDate: selectedDate,
        canBook
      }
    }
    this.navCtrl.navigateForward(`/pro/${barberLink}`, navigationExtras);
  }

  roundedRating(rating: number) {
    return Math.round(rating)
  }

  toRange(n: number) {
    return Util.toRange(n)
  }

  openRegisterPro() {
    this.navCtrl.navigateRoot(`/register-new-pro`);
  }

}
